import React from 'react';
import { View } from 'react-native';

import Card from './Card';
import Text from './Text';

import { translate } from '../services/localization/translations';

const QuizzeScreenCard = ({ }) => {
    return (
        <Card
            square={false}
        >
            <View
                style={{
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    padding: 8,
                    paddingHorizontal: 16
                }}
            >
                <Text
                    type='h4'
                    style='bold'
                    textAlign='left'
                    color='text'
                >{translate('quizzeScreen') + ' ⁉️'}</Text>
                <Text
                    type='h4'
                    textAlign='left'
                    color='text'
                >{translate('chooseCategory')}</Text>
            </View>
        </Card>
    );
}

export default QuizzeScreenCard;